module.exports = __webpack_public_path__ + "static/media/pills.9090e785.svg";